import { Environment } from "@amzn/xb-hooks";
import { ExperienceProviderConfig } from "@amzn/aws-tc-xb-xps";
import registry from "./experience-providers.json";
import { remapEnvironment } from "./getXpsConfig";

type XpsRegistryEntry = Partial<
  Record<Environment, { LiveComponentsEndpoint: string }>
> & {
  name: string;
};

/**
 * Fetch the default global registry of xps endpoints.
 *
 * While a "local" endpoint for an XPS doesn't make a lot of sense in a
 * global registry, the actual usage of this will likely want the "beta" endpoints when
 * running in the "local" stage.
 *
 * @param env - The environment of the XB Application
 * @returns the resolved ExperienceProviderConfigs to be used for LiveComponent lookups
 */
export function getDefaultXpsConfig(env: Environment): ExperienceProviderConfig[] {
  const remappedEnv = remapEnvironment(env);
  return (registry as XpsRegistryEntry[])
    .filter((xps) => xps[remappedEnv] !== undefined)
    .map((xps) => ({
      name: xps.name,
      componentEndpoint: xps[remappedEnv]!.LiveComponentsEndpoint,
    }));
}